import React, {FC, useState} from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import tracking from "@irati-tracking/search"
import SearchBar from "@irati-web/search/src/components/Popups/SearchBar"
import mainTheme from "@irati/ui/src/global/theme"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {StyledFakeSearch, StyledFakeSearchContainer, StyledFakeSearchText} from "./styled/DealSearch"

interface DealSearchProps extends InjectIntl {}

const DealSearch: FC<DealSearchProps> = ({formatMessage}) => {
  const [showSearchBar, setShowSearchBar] = useState<boolean>(false)

  const handleSearch = () => {
    if (!showSearchBar) {
      tracking.startSearch()
    }

    setShowSearchBar((current) => !current)
  }

  return (
    <>
      <StyledFakeSearchContainer onClick={handleSearch}>
        <StyledFakeSearch>
          <Icon id="searchIcon" icon={IconTypes.search} color={mainTheme.colors.greys.mediumDark} size={24} />
          <StyledFakeSearchText>
            {formatMessage({id: "perks.search.searchBar.placeholder"})}
          </StyledFakeSearchText>
        </StyledFakeSearch>
      </StyledFakeSearchContainer>
      <SearchBar id="searchBarId" show={showSearchBar} onClose={handleSearch} isMobile />
    </>
  )
}

export default injectIntl(DealSearch)
